















import Enumerable from "linq";
import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { Table } from "element-ui";
import { FormatReference } from "../../../domain/format";
import { ModelEditableMixin } from "../../system/mixins";

@Component({
})
export default class FormatListSelector extends Mixins(ModelEditableMixin) {
  @Prop()
  formats: FormatReference[];

  get hasFormats(): boolean {
    return (0 < this.formatCount);
  }

  get formatCount(): number {
    return this.formats.length;
  }

  @Watch("value")
  onValueUpdated(newValue: FormatReference, oldValue: FormatReference): void {
    this.editingSource = this.toSelectedFormat(newValue);
  }

  @Watch("formats")
  onFormatsUpdated(newValue: FormatReference[], oldValue: FormatReference[]): void {
    this.editingSource = this.toSelectedFormat(this.editingSource);
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: FormatReference, oldValue: FormatReference): void {
    this.updateSelection();
  }

  mounted(): void {
    this.editingSource = this.toSelectedFormat(this.value);
    this.updateSelection();
  }

  private updateSelection(): void {
    const selector = this.$refs.selector as Table;
    if (!this.editingSource) {
      selector.clearSelection();
    } else {
      selector.setCurrentRow(this.editingSource);
    }
  }

  handleSelectionChanged(row: FormatReference) {
    this.editingSource = row;
  }

  handleRowDoubleClicked(row: FormatReference) {
    this.editingSource = row;
    this.doubleClick(row);
  }

  @Emit()
  doubleClick(format: FormatReference) {}

  private toSelectedFormat(format: FormatReference): FormatReference {
    return Enumerable.from(this.formats)
      .firstOrDefault(f => f === format);
  }
}
